export default __webpack_public_path__ + "static/media/logo.77dcefc2.svg";